import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Portfolio from "../components/site/Portfolio";
import Savings from "../components/site/Savings";
import Story from "../components/site/Story";
import ServiceArea from "../components/site/ServiceArea";
import QuoteForm from "../components/site/QuoteForm";
import Merch from "../components/site/Merch";
import Reviews from "../components/site/Reviews";
import Footer from "../components/site/Footer";
import StickyMobileCTA from "../components/site/StickyMobileCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Portfolio />
        <Savings />
        <Merch />
        <Story />
        <ServiceArea />
        <QuoteForm />
        <Reviews />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
